import { AnaColumn } from "../forms-template.service";

export const elencoAttivitaGrid: AnaColumn[] = [{
  configuration:
  {
    service: 'elencoAttivitaGrid',
    api: 'diario',
    api_rest: true,
    filterList: '',
    filterEditor: '/$',
    // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
    formType: 'simple',
    queryFilter: [],
    idTabRif: [],
    costantValues: [],
    masterKey: 'id',
    nCol: 1,

  },
  itemType: "group", colCount: "1", class: "", caption: "Elenco Attività",
  data: [
    {
      type: 'campo',
      dataField: 'Stato',
      colVisible: true,
      visible: false,
      dataType: 'number',
      caption: 'Stato',
      colAlignment: 'left',
      width: 100,
      lista: {
        dataSource: 'statiDiario',
        displayExpr: 'value',
        valueExpr: 'key',
        static: true,
        costantValues: [],
        isDefaultOption: false,
      }
    },
    {
      type: 'campo',
      dataField: 'CodContatto',
      colVisible: true,
      disabled: true,
      readonly: true,
      disableOnUpdate: true,
      showDropDownButton: false,
      class: 'disabileVisibile pe-none',
      dataType: 'string',
      caption: 'Contatto',
      colAlignment: 'left',
      colWidth: 150,
      lookup: {
        dataSource: 'contatti',
        valueExpr: 'Cod',
        displayExpr: 'RagSoc',
      }
    },
    {
      type: 'campo',
      dataField: 'UtenteCheConclude',
      colVisible: true,
      visible: true,
      dataType: 'string',
      caption: 'Assegnato A',
      colAlignment: 'left',
      colWidth: 100,
      lista: {
        dataSource: 'account',
        displayExpr: 'nomeCompleto',
        valueExpr: 'id',
        wingap: true,
        static: false,
        costantValues: [],
      }
    },

    {
      type: 'campo',
      dataField: 'CodContatto',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'CodContatto',
      colAlignment: 'center',
    },

    {
      type: 'campo',
      dataField: 'CodSede',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'CodSede',
      colAlignment: 'center',
    },

    {
      type: 'campo',
      dataField: 'id',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'ID',
      labelPosition: 'center',
      width: 40,
      colWidth: '40px'
    },
    
    {
      type: 'campoData',
      dataType: 'date',
      dataField: 'DataInserimento',
      format: "dd/MM/yyyy",
      editorType: "dxDateBox",
      showClearButton: true,
      showDropDownButton: false,
      disabled: true,
      disableOnUpdate: true,
      readonly: true,
      colVisible: true,
      class: 'pe-none',
      caption: 'Data Inserimento',
      colAlignment: 'center',
      colWidth: 120

    },
    {
      type: 'campoData',
      dataType: 'date',
      dataField: 'DataConclusione',
      format: "dd/MM/yyyy",
      editorType: "dxDateBox",
      showClearButton: true,
      showDropDownButton: false,
      disabled: true,
      disableOnUpdate: true,
      readonly: true,
      colVisible: true,
      class: 'pe-none',
      caption: 'Data Conclusione',
      colAlignment: 'center',
      colWidth: 120

    },
    
    {
      type: 'campo',
      dataField: 'Tipo',
      colVisible: true,
      visible: true,
      dataType: 'string',
      caption: 'Tipo',
      colAlignment: 'left',
      width: 120,
      editorType: 'dxSelectBox',
      lista: {
        dataSource: "tabella",
          queryString: "?tipo=9",
        displayExpr: 'descrizione',
        valueExpr: 'id',           
        wingap: false,
        static: false,
        costantValues: [
          { key: 'tipo', value: 9 }
        ]
      }
    },

    {
      type: 'campo',
      dataField: 'Descrizione',
      colVisible: true,
      dataType: 'string',
      caption: 'Richiesta',
      allowEditing: true,
      colAlignment: 'left',
      colWidth: 500
    },

    {
      type: 'campo',
      dataField: 'Soluzione',
      colVisible: true,
      dataType: 'string',
      caption: 'Soluzione',
      allowEditing: true,
      colAlignment: 'left',
    },
    {
      type: 'campo',
      dataField: 'fonte',
      colVisible: true,
      visible: true,
      dataType: 'string',
      caption: 'Fonte',
      colAlignment: 'left',
      width: 120,
      editorType: 'dxSelectBox',
      lista: {
        dataSource: "tabella",
        queryString: "?tipo=22",
        displayExpr: 'descrizione',
        valueExpr: 'id',
        wingap: false,
        static: false,
        costantValues: [
          { key: 'tipo', value: 22 }
        ]
      }
    },
  ]
}]
export const elencoAttivitaForm: AnaColumn[] = [
  {
    itemType: "group", colCount: "4", class: '', caption: "Filtri", colGroup: 10, captionClass: 'border-0',
    data: [

      {
        type: 'campo',
        dataField: 'UtenteCheInserisce',
        class: 'crm_contatti_editor me-2',
        odataType: 'select',
        odataFilter: 'in',
        dataType: 'string',
        caption: 'Inserito Da',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'account',
          displayExpr: 'nomeCompleto',
          valueExpr: 'id',
          wingap: true,
          static: false,
          costantValues: [],
        }
      },
      {
        type: 'campo',
        dataField: 'Stato',
        class: 'crm_contatti_editor me-2',
        odataType: 'select',
        odataFilter: 'in',
        dataType: 'string',
        caption: 'Stato',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'statiDiario',
          displayExpr: 'value',
          valueExpr: 'key',
          static: true,
          costantValues: [],
          isDefaultOption: false,
        }
      },
      {
        type: 'campo',
        dataField: 'Tipo',
        class: 'crm_contatti_editor me-2',
        odataType: 'select',
        odataFilter: 'in',
        dataType: 'string',
        caption: 'Tipo',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'tabella',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          queryString: '?tipo=9',
          wingap: false,
          static: false,
          costantValues: [
            { key: 'tipo', value: 9 }
          ]
        }
      },
      {
        type: 'campo',
        dataField: 'fonte',
        class: 'crm_contatti_editor me-2',
        odataType: 'select',
        odataFilter: 'in',
        dataType: 'string',
        caption: 'Fonte',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: "tabella",
          queryString: "?tipo=22",
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          costantValues: [
            { key: 'tipo', value: 22 }
          ]
        }
      },
    ],

  },
  {
    itemType: "group", colCount: "2", class: '', caption: "Data Inserimento", colGroup: 2,
    data: [
      {
        type: 'campoData',
        dataType: 'date',
        dataField: 'DataInserimento',
        staticDataField: 'DataInserimento',
        format: 'dd/MM/yyyy',
        editorType: "dxDateBox",
        class: 'crm_contatti_editor me-2',
        odataType: 'string',
        odataFilter: '>=',
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Inizio',
        colAlignment: 'center'

      },
      {
        type: 'campo',
        dataField: 'DataFine',
        staticDataField: 'DataInserimento',
        class: 'crm_contatti_editor me-2',
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        odataType: 'string',
        odataFilter: '<=',
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Fine',
        colAlignment: 'center'
      },
    ]
  },
  {
    itemType: "group", colCount: "2", class: '', caption: "Data Conclusione", colGroup: 2,
    data: [
      {
        type: 'campoData',
        dataType: 'date',
        dataField: 'DataConclusione',
        staticDataField: 'DataConclusione',
        format: 'dd/MM/yyyy',
        editorType: "dxDateBox",
        class: 'crm_contatti_editor me-2',
        odataType: 'string',
        odataFilter: '>=',
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Inizio',
        colAlignment: 'center'

      },
      {
        type: 'campo',
        dataField: 'DataFineConclusione',
        staticDataField: 'DataConclusione',
        class: 'crm_contatti_editor me-2',
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        odataType: 'string',
        odataFilter: '<=',
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Fine',
        colAlignment: 'center'
      },
    ]
  },



]